import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { version as REACT_VERSION } from 'react';
import memoizeOne from 'memoize-one';
var MODULE_NAME = '@atlassian/app-switcher-remote-module';
var MODULE_URI_STG = 'https://remote-app-switcher.stg-east.frontend.public.atl-paas.net/assets/';
var MODULE_URI_PROD = 'https://remote-app-switcher.prod-east.frontend.public.atl-paas.net/assets/';
var EXTERNALS = [{
  name: 'react'
}, {
  name: 'react-dom'
}, {
  name: 'react-intl-next'
}, {
  name: '@emotion/react'
}];
var RemoteSwitcherPlugin = /*#__PURE__*/function () {
  function RemoteSwitcherPlugin(dimensions, config) {
    var _this = this;
    _classCallCheck(this, RemoteSwitcherPlugin);
    _defineProperty(this, "_manifestMap", new Map([['local', new Map([['latest', {
      moduleName: MODULE_NAME,
      moduleUri: 'http://localhost:9001/',
      externals: EXTERNALS
    }]])], ['staging', new Map([['latest', {
      moduleName: MODULE_NAME,
      moduleUri: MODULE_URI_STG,
      externals: EXTERNALS
    }], ['stable', {
      moduleName: MODULE_NAME,
      moduleUri: MODULE_URI_STG,
      externals: EXTERNALS
    }]])], ['production', new Map([['latest', {
      moduleName: MODULE_NAME,
      moduleUri: MODULE_URI_PROD,
      externals: EXTERNALS
    }], ['stable', {
      moduleName: MODULE_NAME,
      moduleUri: MODULE_URI_PROD,
      externals: EXTERNALS
    }]])]]));
    /**
     * This is optional and when defined can be used to override the logic for creating the moduleUri.
     * If it isn't defined or passed in then we will use the moduleUri from the manifestMap as per the defined dimensions.
     *
     * @param uri
     * @param variant
     * @param computeHash
     */
    _defineProperty(this, "moduleUriMapper", memoizeOne(function (uri) {
      var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
      var computeHash = arguments.length > 2 ? arguments[2] : undefined;
      // We want to hash the major version of React installed, alongside the chosen variant
      var hashedDependencies = ['react', 'react-dom'];
      var hashedValues = hashedDependencies.reduce(function (acc, dep) {
        return acc.concat([{
          name: dep,
          version: REACT_VERSION.split('.')[0]
        }]);
      }, []);
      var hash = computeHash(variant, hashedValues);
      var cacheTime = Date.now().toString().substring(0, 6); // approx 3hrs

      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.debug("[@atlassian/remote-module-loader]: Computed hash for plugin [".concat(_this.constructor.name, "] with variant [").concat(variant, "] and values ").concat(JSON.stringify(hashedValues), "."));
      }
      return "".concat(uri).concat(hash, ".js?t=").concat(cacheTime);
    }));
    this._dimensions = dimensions;

    // allow either of these config options to be overridden
    if (config) {
      if (config.manifestMap) {
        this._manifestMap = config.manifestMap;
      }
      if ('moduleUriMapper' in config) {
        this.moduleUriMapper = config.moduleUriMapper;
      }
    }
  }
  _createClass(RemoteSwitcherPlugin, [{
    key: "bifrostOverrideKey",
    get: function get() {
      return 'remote-app-switcher-bifrost-override';
    }
  }, {
    key: "dimensions",
    get: function get() {
      return this._dimensions;
    }
  }, {
    key: "manifestMap",
    get: function get() {
      return this._manifestMap;
    }
  }]);
  return RemoteSwitcherPlugin;
}();
export default RemoteSwitcherPlugin;